import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AskGeoResultComponent } from './ask-geo-result/ask-geo-result.component';
import { RoleGaurd } from 'src/app/shared/services/role-gaurd.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';

const routes: Routes = [
  {
    path: '',
    component : AskGeoResultComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin',],
      title: 'Ask Geo',
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, MatExpansionModule, MatTooltipModule    ]
})
export class AskGeoRoutingModule { }
